export enum GroupingSupport {
    None = "none",
    Regular = "regular",
    // This means that the hydrator applies grouping to whichever rows it
    // finds itself with, which means that it works with queryables without
    // having to query specially.
    InMemory = "in-memory",
}
